export function upgradeDeprecated(message) {
  if (message.entities[0].hasOwnProperty('text')) {
    message.entities[0].text = message.entities[0].text.replace(
      /{{um:([^{}]*)}}/gm,
      '<span data-mention="$1,,"></span>'
    );
  }
}
